import { render } from "./NavNotif.vue?vue&type=template&id=88e3d582"
import script from "./NavNotif.vue?vue&type=script&lang=js"
export * from "./NavNotif.vue?vue&type=script&lang=js"

import exportComponent from "/var/www/html/amatra-frontend-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__